import { ENTITY_TAB_CATEGORIES_SCALAR_SCOPE_FILTER_KEYS } from './EntityTabCategories.constants'

export function getEntityTabCategoriesScopeFilter({ scopeFilterKey, scopeId }) {
  return {
    [scopeFilterKey]: ENTITY_TAB_CATEGORIES_SCALAR_SCOPE_FILTER_KEYS.includes(
      scopeFilterKey
    )
      ? scopeId
      : [scopeId],
  }
}
